/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.pageViewModule')
  .controller('PageViewFooterLoginController', [
    'CONFIG',
    '$scope',
    '$state',
    '$window',
    'google',
    'BulbAuthService',
    'BulbBrowserService',
    'BulbBusyService',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    PageViewFooterLoginController,
  ]);

/**
 * AngularJS Authentication controller for footer of a page view.
 */
function PageViewFooterLoginController(
  CONFIG,
  $scope,
  $state,
  $window,
  google,
  BulbAuthService,
  BulbBrowserService,
  BulbBusyService,
) {

  const that = this;
  this.credentials = {
    usernameOrEmail: '',
    password: '',
  };

  this.signInUnsuccessful = false;
  this.signInWithGoogleInProgress = false;
  this.googleSignInReady = false;
  this.cleverIntegrationEnabled = CONFIG.features.cleverIntegrationEnabled;

  // Boolean to check if our app is running as a hosted webapp, PWA.
  this.runningInPWAEnvironment = BulbBrowserService.isPWAEnvironment();

  // Load the gapi auth2
  if (google.load) {
    google.load('auth2', () => {
      that.googleSignInReady = true;
    });
  }

  /**
   * Sign in the user using the credentials provided via the signIn form.
   */
  this.signIn = function signIn() {
    BulbBusyService.showBusyDuring(
      BulbAuthService.signIn(that.credentials).then(
        redirectAfterSignIn,
        (/* error */) => {
          that.signInUnsuccessful = true;
        },
      ),
    );
  };

  /**
   * Sign in the user via Google authentication.
   */
  this.signInWithGoogle = function signInWithGoogle() {
    const params = $scope.targetUrl ? `&targetUrl=${encodeURIComponent(`${$scope.targetUrl}?uid=${
      $scope.unitId}`)}` : '';
    // eslint-disable-next-line no-param-reassign
    $window.location.href = `/b/auth/google?entryMode=sign-in${params}`;
  };

  /**
   * Sign in the user via Microsoft authentication.
   */
  this.signInWithMicrosoft = function signInWithMicrosoft() {
    const params = $scope.targetUrl ? `&targetUrl=${encodeURIComponent(`${$scope.targetUrl}?uid=${
      $scope.unitId}`)}` : '';
    // eslint-disable-next-line no-param-reassign
    $window.location.href = `/b/auth/microsoft?entryMode=sign-in${params}`;
  };

  /**
   * Sign in the user via Clever authentication.
   */
  this.signInWithClever = function signInWithClever() {
    const params = $scope.targetUrl ? `&targetUrl=${encodeURIComponent(`${$scope.targetUrl}?uid=${
      $scope.unitId}`)}` : '';
    // eslint-disable-next-line no-param-reassign
    $window.location.href = `/b/auth/clever?entryMode=sign-in${params}`;
  };

  this.signUp = function signUp() {
    closeTheModal();
    const params = $scope.targetUrl ? `&targetUrl=${encodeURIComponent($scope.targetUrl)}` : '';
    // eslint-disable-next-line no-param-reassign
    $window.location.href = `/b/sign-up?${params}`;
  };

  /**
   * Close the signIn modal.
   */
  function closeTheModal() {
    if ($scope.$close) {
      $scope.$close();
    }
  }

  /**
   * Method called after successful user authentication.
   */
  function redirectAfterSignIn() {
    closeTheModal();
    localStorage.setItem('isAuthorized', 'isAuthorized');
    // eslint-disable-next-line no-param-reassign
    $window.location.href = $scope.targetUrl;
  }

  /**
   * Function to redirect the user to the 'forgot password' state
   */
  this.forgotPassword = function forgotPassword() {
    $state.go('resetPassword');
    closeTheModal();
  };
}
